import styles from './Conditional.module.css';

const SlewRate = ({
    d,
    value,
    onUpdateConditionalField,
}: {
    d: string;
    value: any;
    onUpdateConditionalField: Function;
}) => {
    return (
        <div className={styles.conditionalGroup}>
            <div>
                <input
                    min={0}
                    type="number"
                    onWheel={(e: any) => e.target.blur()}
                    step="any"
                    defaultValue={value?.rate || ''}
                    placeholder="Rate"
                    onChange={(e) => {
                        onUpdateConditionalField(d, {
                            ...value,
                            rate: e.target.value
                                ? Number(e.target.value)
                                : undefined,
                        });
                    }}
                />
            </div>
            <div>
                <input
                    type="text"
                    defaultValue={value?.condition || ''}
                    placeholder="Condition"
                    onChange={(e) => {
                        onUpdateConditionalField(d, {
                            ...value,
                            condition: e.target.value,
                        });
                    }}
                />
            </div>
        </div>
    );
};

export default SlewRate;
